import { inboxClient } from '../utils/client'

export const FETCH_INBOX_CONFIG = 'FETCH_INBOX_CONFIG'
export const FETCH_INBOX_CONFIG_SUCCESS = 'FETCH_INBOX_CONFIG_SUCCESS'
export const FETCH_INBOX_CONFIG_ERROR = 'FETCH_INBOX_CONFIG_ERROR'

export function getInboxConfig(
  centerId = localStorage.getItem('selected_center_id')
) {
  return dispatch => {
    dispatch({ type: FETCH_INBOX_CONFIG })

    const request = inboxClient({
      url: `all-inboxes/?center_id=${centerId}`
    })

    request
      .then(({ data }) => {
        dispatch({
          type: FETCH_INBOX_CONFIG_SUCCESS,
          payload: data
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_INBOX_CONFIG_ERROR,
          payload: err.response?.data || {
            error: 'Failed to fetch inbox config'
          }
        })
      })
  }
}
